import { useState } from "react"
import classNames from "classnames"
import Typography from "component-lib/Base/components/Typography"
import { makeStyles } from "tss-react/mui"
import { ReactSVG } from "react-svg"
import ReactPlayer from "react-player"
import getContentUrl from "utils-lib/getContentUrl"
import { getWindow } from "utils-lib/getWindow"
import { Button, GenericModal } from "../../../Base"
import "./sevenCard.scss"

const ssrWindow = getWindow()

const useStyles = makeStyles()((theme) => ({
  headingDisplay: {
    [theme.breakpoints.down(`sm`)]: {
      paddingLeft: `1.5rem`,
      paddingRight: `10px`,
    },
  },
  cardwrapper: {
    [theme.breakpoints.down(`sm`)]: {
      gap: `0 !important`,
    },
    fontSize: `1.5rem`,
  },
  bodyCardText: {
    maxWidth: "40rem",
  },
}))

const Profilecard = (cardList, collapse) => {
  const bodyWidth =
    ssrWindow.innerWidth > 0 ? ssrWindow.innerWidth : ssrWindow.screen.width
  const [isExpand, setIsExpand] = useState(false)
  const symbol = isExpand ? `minus` : `plus`
  const [isopenModal, setIsopenModal] = useState(false)
  const [isopenvideoModal, setIsopenvideoModal] = useState(false)
  const [isPlaying] = useState(true)

  const { classes, cx } = useStyles()

  const modalopenbody = (cardList) => (
    <div
      className="Modalcard"
      role="dialog"
      aria-modal="true"
      aria-label={cardList?.cardList?.imageAltText}
    >
      <div className="modalcardImage">
        <img
          className="card-img-top img-circle rounded-circle"
          src={getContentUrl(cardList?.cardList?.cardImage)}
          alt={cardList?.cardList?.imageAltText}
          style={{ width: "10rem", height: "10rem", objectFit: "cover" }}
        />
      </div>
      <div className="Modalcard-block">
        <div className="">
          <h1 className="maax-font-weight-bold cardItemtitle">
            {cardList?.cardList?.cardHeading}
          </h1>
          <div className="cardHeading maax-font-weight-black">
            {cardList?.cardList?.cardSubhead}
          </div>
          <div
            className={classNames(
              "flex-grow-1 cardItemsubText maax-font-weight-regular",
              classes.bodyCardText,
            )}
          >
            {cardList?.cardList?.cardBody}
          </div>
          {cardList?.cardList?.videoPath &&
            cardList?.cardList?.videoCtaText && (
              <div className="linkprofilevideo">
                <Button
                  onClick={() => {
                    setIsopenvideoModal(!isopenvideoModal)
                    setIsopenModal(false)
                  }}
                  overrideClass="maax-font-weight-regular link videoCTA"
                >
                  {cardList?.cardList?.videoCtaText}
                </Button>
              </div>
            )}
        </div>
      </div>
    </div>
  )

  const handleOpenModal = () => {
    const prodScript =
      "https://assets.adobedtm.com/3010f46ab2ec/a3cbfcd83a52/launch-4688d17a7429.min.js"
    const lowerEnvScript =
      "https://assets.adobedtm.com/3010f46ab2ec/a3cbfcd83a52/launch-01b1cb6f5edd-development.min.js"
    const scriptSrc =
      process.env.REACT_APP_NODE_ENV === `prod` ? prodScript : lowerEnvScript
    const isScript = ssrWindow.document.getElementById("analyticScript")

    setIsopenvideoModal(isopenvideoModal)

    isScript && isScript.remove()
    const script = ssrWindow.document.createElement("script")
    script.src = scriptSrc
    script.id = "analyticScript"
    script.async = true
    ssrWindow.document.body.appendChild(script)
  }

  const modalvideobody = (cardList) => (
    <div className="Modalcard">
      <div className="Video">
        {cardList?.cardList?.videoPlayIcon ? (
          <Button
            className={cx(
              "playButtonClass",
              `justify-content-center align-items-center p-0 play-icon-wrapper`,
              !isopenvideoModal ? `d-flex` : `d-none`,
            )}
            onClick={() => {
              handleOpenModal
            }}
            ariaHasPopup="dialog"
            tabIndex={isopenModal ? `-1` : `0`}
          >
            <ReactSVG
              wrapper="span"
              src={getContentUrl(cardList?.cardList?.videoPlayIcon)}
              alt="play icon"
            />
          </Button>
        ) : null}
        <div>
          <ReactPlayer
            playing={isPlaying}
            className={
              cardList?.cardList?.videoCtaSource === `youtube`
                ? `youtube-player`
                : `video-player`
            }
            url={
              cardList?.cardList?.videoCtaSource === `youtube`
                ? cardList?.cardList?.videoPath
                : getContentUrl(cardList?.cardList?.videoPath)
            }
            controls
            onPause={() => {
              setIsopenModal(!isPlaying)
            }}
          />
          <Button
            ariaLabel="close video"
            analytics_key={`close video ${cardList?.cardList?.mediaSrc}`}
            overrideClass="bg-transparent d-flex align-items-center justify-content-center"
            tabIndex={isopenvideoModal ? `0` : `-1`}
            onClick={() => {
              setIsopenvideoModal(!isopenvideoModal)
            }}
            style={{
              borderRadius: `1.1rem`,
              height: `2.2rem`,
              opacity: 0.8,
              position: `absolute`,
              right: `0rem`,
              top: `0.5rem`,
              width: `2.2rem`,
            }}
          >
            <div
              style={{
                position: `relative`,
                top: `.1rem`,
              }}
            >
              <ReactSVG
                wrapper="span"
                src={getContentUrl(
                  "/content/dam/wm/icons/white-close-x-icon.svg",
                )}
              />
            </div>
          </Button>
        </div>
      </div>
    </div>
  )

  return (
    <>
      <div className="Profilecard" data-testid="ProfileCard">
        <div className="card">
          <img
            className="card-img-top img-circle rounded-circle"
            src={getContentUrl(cardList?.cardList?.cardImage)}
            alt={cardList?.cardList?.imageAltText}
          />
          <div className="card-block">
            <div
              className={`${
                cardList?.cardList?.cardImage
                  ? "WmcontentcardwithImage"
                  : "WmcontentcardwithoutImage"
              }`}
            >
              <Typography
                className="maax-font-weight-bold cardItemtitle"
                variant={bodyWidth < 1025 ? "h4" : "h3"}
                style={{ color: "black" }}
              >
                {cardList?.cardList?.cardHeading}
              </Typography>
              <div className="cardHeading maax-font-weight-black">
                {cardList?.cardList?.cardSubhead}
              </div>
              <div className="flex-grow-1 cardItemsubText maax-font-weight-regular">
                {cardList?.cardList?.cardBody.substring(0, 200)}. . .
              </div>
              <div className="linkprofilevideo">
                {cardList?.cardList?.cardCtaText && (
                  <Button
                    ariaLabel={`${cardList?.cardList?.cardHeading}${cardList?.cardList?.cardCtaText}`}
                    overrideClass="maax-font-weight-regular link"
                    onClick={() => {
                      setIsopenModal(true)
                    }}
                  >
                    {cardList?.cardList?.cardCtaText}
                  </Button>
                )}
                {cardList?.cardList?.videoCtaText && (
                  <Button
                    onClick={() => {
                      setIsopenvideoModal(!isopenvideoModal)
                    }}
                    ariaLabel={cardList?.cardList?.videoCtaText}
                    overrideClass="maax-font-weight-regular link"
                    href={cardList?.cardList?.videoCtaText}
                  >
                    {cardList?.cardList?.videoCtaText}
                  </Button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="ProfileVideoModal">
        {isopenvideoModal ? (
          <GenericModal
            {...{
              open: isopenvideoModal,
            }}
            useFlexibleWidth
            showCloseButton
          >
            {modalvideobody(cardList)}
          </GenericModal>
        ) : (
          ""
        )}
      </div>
      <div className="ProfileModal">
        <GenericModal
          {...{
            open: isopenModal,
            onClose: () => {
              setIsopenModal(false)
            },
          }}
          useFlexibleWidth
          showCloseButton
        >
          {modalopenbody(cardList)}
        </GenericModal>
      </div>
      {collapse ? (
        <div className="ServiceSolutioncardMobile ProfilecardMobile">
          <div
            {...{
              className: `accordion-item accordion-item--${
                isExpand ? `opened` : `cloosed`
              }`,
            }}
          >
            <Button
              overrideClass={` accordion-item__line text-left Body accordion-item__title maax-font-weight-bold`}
              analytics_key={`${symbol}`}
              ariaExpanded={isExpand}
              ariaLabel={cardList?.cardList?.cardHeading}
              onClick={() => {
                setIsExpand(!isExpand)
              }}
            >
              <span
                className={`${classes.headingDisplay}`}
                style={{ display: !isExpand ? "block" : "none" }}
              >
                {cardList?.cardList?.cardHeading}
              </span>
              <div className={`accordion-item__icon  ${symbol}`}>
                <ReactSVG
                  wrapper="span"
                  src={
                    !isExpand
                      ? getContentUrl(`/content/dam/wm/icons/plus-green.svg`)
                      : getContentUrl(`/content/dam/wm/icons/minus-green.svg`)
                  }
                />
              </div>
            </Button>
            <div
              {...{ className: `accordion-item__inner` }}
              style={{ background: !isExpand ? "" : "white" }}
            >
              <img
                aria-hidden={!isExpand}
                className="card-img-top img-circle rounded-circle"
                src={getContentUrl(cardList?.cardList?.cardImage)}
                alt={cardList?.cardList?.imageAltText}
              />
              <div className="card-block" aria-hidden={!isExpand}>
                <div
                  className={`${
                    cardList?.cardList?.cardImage
                      ? "WmcontentcardwithImage"
                      : "WmcontentcardwithoutImage"
                  }`}
                >
                  <h4 className="maax-font-weight-bold cardItemtitle">
                    {cardList?.cardList?.cardHeading}
                  </h4>
                  <div className="cardHeading maax-font-weight-black">
                    {cardList?.cardList?.cardSubhead}
                  </div>
                  <div className="flex-grow-1 cardItemsubText maax-font-weight-regular">
                    {cardList?.cardList?.cardBody.substring(0, 200)}. . .
                  </div>
                  <div className="linkprofilevideo">
                    {cardList?.cardList?.cardCtaText && (
                      <Button
                        tabIndex={isExpand ? `0` : `-1`}
                        onClick={() => {
                          setIsopenModal(true)
                        }}
                        overrideClass="maax-font-weight-regular link"
                        href={cardList?.cardList?.cardCtaURL}
                      >
                        {cardList?.cardList?.cardCtaText}
                      </Button>
                    )}
                    {cardList?.cardList?.videoCtaText && (
                      <Button
                        onClick={() => {
                          setIsopenvideoModal(!isopenvideoModal)
                        }}
                        overrideClass="maax-font-weight-regular link"
                        href={cardList?.cardList?.videoCtaText}
                      >
                        {cardList?.cardList?.videoCtaText}
                      </Button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
    </>
  )
}
export default Profilecard
